import { TextInputField, Textarea, Button, Pane, Heading, toaster, SelectMenu } from 'evergreen-ui';
import { SendMessageIcon } from 'evergreen-ui';
import FileUploaderMultipleUploadDemo from '../commons/FileUploaderMultipleUploadDemo';
import { addCommunication } from '../services/communicationServices';

const AddCommunicationForm = ({ newCommunication, setNewCommunication, setIsAdding, setCommunications, isDirector, userId, fetchCommunications, collaborators = [], onCommunicationAdded }) => {
    
    newCommunication.recipients = newCommunication.recipients || [];
    newCommunication.attachments = newCommunication.attachments || [];

    const handleAddCommunication = async () => {
        try {
            const formData = new FormData();
            formData.append('title', newCommunication.title);
            formData.append('body', newCommunication.body);
            formData.append('author_id', userId);
            formData.append('recipients', JSON.stringify(newCommunication.recipients));

            if (newCommunication.attachments.length > 0) {
                newCommunication.attachments.forEach((file, index) => {
                    formData.append(`attachments[${index}]`, file);
                });
            }

            const addedCommunication = await addCommunication(formData);

            if (addedCommunication.success) {
                const updatedCommunications = await fetchCommunications();
                setCommunications(updatedCommunications?.data ?? []);
                onCommunicationAdded && onCommunicationAdded(); 
                setNewCommunication({ title: '', body: '', recipients: [], attachments: [] });
                setIsAdding(false);
                toaster.success('Comunicazione pubblicata con successo.');
            } else {
                toaster.danger('Errore durante l\'aggiunta della comunicazione.');
            }
        } catch (error) {
            toaster.danger('Errore durante l\'aggiunta della comunicazione.');
        }
    };

    const handleFilesChange = (acceptedFiles) => {
        setNewCommunication((prev) => ({
            ...prev,
            attachments: acceptedFiles,
        }));
    };

    return (
        <Pane>
            <Heading size={600} marginBottom={16}>
                Aggiungi nuova comunicazione
            </Heading>
            <TextInputField
                label="Titolo"
                placeholder="Inserisci il titolo della comunicazione..."
                value={newCommunication.title}
                onChange={(e) => setNewCommunication({ ...newCommunication, title: e.target.value })}
                marginBottom={16}
            />
            <Textarea
                label="Corpo"
                placeholder="Scrivi il corpo della comunicazione..."
                value={newCommunication.body}
                onChange={(e) => setNewCommunication({ ...newCommunication, body: e.target.value })}
                marginBottom={16}
                resize="none"
                height={120}
            />
            <SelectMenu
                title="Seleziona destinatari"
                isMultiSelect
                options={[
                    { label: "Tutti", value: "Tutti" },
                    ...((Array.isArray(collaborators) ? collaborators : []).map((collaborator) => ({
                        label: `${collaborator.nome} ${collaborator.cognome}`,
                        value: collaborator.id,
                    })) || []),
                ]}
                selected={newCommunication.recipients}
                onSelect={(item) => {
                    const updatedRecipients =
                        item.value === "Tutti"
                            ? ["Tutti"]
                            : [...newCommunication.recipients.filter((r) => r !== "Tutti"), item.value];
                    setNewCommunication({
                        ...newCommunication,
                        recipients: updatedRecipients,
                    });
                }}
                onDeselect={(item) => {
                    const updatedRecipients =
                        item.value === "Tutti"
                            ? []
                            : newCommunication.recipients.filter((recipient) => recipient !== item.value);
                    setNewCommunication({
                        ...newCommunication,
                        recipients: updatedRecipients,
                    });
                }}
            >
                <Button marginBottom={16}>{
                    newCommunication.recipients.length > 0
                        ? newCommunication.recipients.includes("Tutti")
                            ? "Tutti"
                            : `${newCommunication.recipients.length} selezionati`
                        : "Seleziona destinatari"
                }</Button>
            </SelectMenu>
            {isDirector && (
                <FileUploaderMultipleUploadDemo
                    onFilesChange={handleFilesChange} 
                />
            )}
            <Button
                iconBefore={SendMessageIcon}
                appearance="primary"
                intent="success"
                onClick={handleAddCommunication}
                width="8.4rem"
            >
                Invia
            </Button>
        </Pane>
    );
};

export default AddCommunicationForm;